import { Component, Input, OnInit } from '@angular/core';
import { ModalComponent } from '../../common/modal/modal.component';

@Component({
  selector: 'ark-value-importance',
  templateUrl: './value-importance.component.html',
  styleUrls: ['./value-importance.component.scss'],
})
export class ValueImportanceComponent implements OnInit {
  entryId!: number;
  weightId!: number;
  title!: string;
  points: { label: string; value: number }[] = [];
  activePoint!: number;

  type: 'slider' | 'button' = 'button';

  constructor(protected readonly parent: ModalComponent) {}

  weights = [
    { id: 1, label: 'Low' },
    { id: 2, label: 'Medium' },
    { id: 3, label: 'High' },
  ];

  ngOnInit(): void {
    this.entryId = this.parent.data['entryId'];
    this.weightId = this.parent.data['weightId'];
    this.title = this.parent.data['title'];
    this.points = this.parent.data.points;
    if (this.points) {
      this.type = 'slider';
    }
  }

  pointSelect(point: number) {
    this.activePoint = point;
  }
  submit(weightId?: number) {
    this.parent.close(weightId ?? this.activePoint);
  }
}
